import { inject, Injectable } from "@angular/core";
import { GraphqlService } from "@lib/core/modules/graphql/graphql-service.service";
import { first, map, of, shareReplay, timer } from "rxjs";
import { MeGraphql } from "@lib/core/services/user-services.graphql";

@Injectable({
    providedIn: "root",
})
export class UserInfoService {
    private graphqlService = inject(GraphqlService);

    private userInfo$ = this.graphqlService.query(MeGraphql).observeWith(of({}));
    private sharedUserInfo$ = this.userInfo$.pipe(
        map(query => query.me),
        shareReplay(1),
    );

    constructor() {
        const twentyMinutes: number = 1_000 * 60 * 20;
        timer(0, twentyMinutes).subscribe(() => {
            this.userInfo$.refresh();
        });
    }

    getRefreshedUserInfo() {
        this.userInfo$.refresh();
        return this.userInfo$.pipe(
            map(query => query.me),
            first(),
        );
    }

    getUserInfo() {
        return this.sharedUserInfo$.pipe(
            first(),
        );
    }

    getUserInfoObservable() {
        return this.sharedUserInfo$;
    }
}
